/**
 * Created by cahyo on 01/22/2018.
 *
 * place this in only in input el! not in the components!
 * dont use v-model! use @change evt only
 */

export default {
  acceptStatement: true,

  bind: function (el: any, binding: any) {
    const param: any = binding && binding.value;

    if (param) {
      const $input = window.$(el);

      if ($input[0]) new window.Cleave($input, param);
    }
  }
}
